import { useTranslation } from "react-i18next";

export function HourBillingBadges({ hour }) {
  const { t } = useTranslation();
  const billing = hour?.billing;
  if (!billing) return null;
  return <div className="flex flex-wrap gap-1 text-xs">
    {billing.invoiced_to_customer && <span className="rounded bg-green-100 px-2 py-1 text-green-800">{t("hourBilling.customer")}</span>}
    {billing.hired && <span className="rounded bg-blue-100 px-2 py-1 text-blue-800">{t("hourBilling.hired")}</span>}
    {billing.hired_invoiced && <span className="rounded bg-green-100 px-2 py-1 text-green-800">{t("hourBilling.supplierInvoiced")}</span>}
    {billing.needs_supplier_invoice && <span className="rounded bg-amber-100 px-2 py-1 text-amber-900">{t("hourBilling.reminder")}</span>}
  </div>;
}
